<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="false"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :indexNested="true"
    :disablePagination="true"
  >

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

   <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action1" slot-scope="{ item }">
      <NewSeedPlotOperation
        :planningOperation="item"
        @entry-created="entryCreated"
        :inlineAddButton="true"
        @new-open-action="loadServerEntries()"
        newCreateButtonLabel="Gerar semeio"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Semeio"
      />
    </template>
  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "@models/operations/planning_seed_plot_operations/new.vue";
import Edit from "@models/operations/planning_seed_plot_operations/edit.vue";
import Delete from "@models/operations/planning_seed_plot_operations/delete.vue";
import NewSeedPlotOperation from "@models/operations/planning_seed_plot_operations/new_seed_plot_operation.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code"},
        { text: "Tipo de Operação", align: "left", sortable: true, value: "operationTypeName"},
        { text: "Cliente", align: "left", sortable: true, value: "clientName"},
        { text: "Variedades", align: "left", sortable: true, value: "variety" },
        { text: "Quantidades", align: "left", sortable: true, value: "quantities" },
        { text: "Data planejada", align: "left", sortable: true, value: "planningDate" },
        { text: "Data executada", align: "left", sortable: true, value: "executionDate" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      // maskFields: [
      //   { field: 'operationDate', mask: 'date'},
      //   { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
      //   { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      // ],
      infoHeaders: [
        { field: 'varietyNames', info: 'Variedades, fertilizantes, agrotóxicos e biológicos consumidos nas operações. *Em operações de destinar semeios as variedades indicadas são as geradas.' },
        { field: 'lots', info: 'Lotes semeados, em estufa ou aplicados'},
        { field: 'quantities', info: 'planejado/semeado/destinado/vendido'},
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    saleOrder:{
      type: Object,
      default: null,
    },
    modelNameSingular: {
      type: String,
      default: "Operação planejada"
    },
    modelNamePlural: {
      type: String,
      default: "Operações planejadas"
    },
    indexItems: {
      type: Array, 
      default: Array.new,
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    NewSeedPlotOperation: NewSeedPlotOperation,
  },
  created() {
    this.totalItems = this.indexItems.length;
    // this.loadServerEntries();
  },
  computed: {
    maskFields() {
      return [
        { field: 'operationDate', mask: 'date'},
        ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
        { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
      ]
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_SEED_PLOT_OPERATIONS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            },
            saleOrderId: this.saleOrder?.id ?? 0
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All executionOperations", response.data.groundContext.executionOperationsIndex);
          this.indexItems = response.data.groundContext.planningSeedPlotOperationsIndex.planningSeedPlotOperationViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          // console.log("index", this.indexItems);
          this.totalItems = response.data.groundContext.planningSeedPlotOperationsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.groundContext.planningSeedPlotOperationsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.groundContext.planningSeedPlotOperationsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      // console.log("entryC chamou ?");
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      // this.loadServerEntries();
    },
  }
};

const LOAD_ALL_SEED_PLOT_OPERATIONS = gql `
  query($input: IndexInputObject!, $saleOrderId: ID) {
    groundContext {
      planningSeedPlotOperationsIndex(input: $input, saleOrderId: $saleOrderId){
        count
        typeOperators
        serverFields      
        planningSeedPlotOperationViewIndexFilters {
          id
          code
          clientName
          planningDate
          variety
          quantities
          executionDate
          operationTypeName
        }
      }
    }
  }
`;

</script>

<style scoped></style>
